<template>
  <div class="auditing-page">
    <div class="auditing-content">
      <vue-lottie class="auditing-lottie" :options="lottieOptions"></vue-lottie>
      <div class="auditing-title">{{status === 'credit' ? '授信' : '提现'}}审核中</div>
      <div class="auditing-info">我们正在加急为您审核，请您耐心等待</div>
      <div class="auditing-button" @click="navigateToHome">返回首页</div>
    </div>
  </div>
</template>

<script>
// 授信审核中页面，3秒后自动跳到授信结果页面（拒绝状态），只是为了给购买授信重审卡的用户展示
import VueLottie from 'vue-lottie'
import waitData from '@/assets/json/wait.json'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { judgeClientSystem } from '@/assets/utils'

export default {
  name: 'AuditingFake',
  components: {
    VueLottie
  },
  data () {
    return {
      status: this.$route.query.status, // 只有credit，不算loan
      applyNo: this.$route.query.applyNo,
      lottieOptions: {
        animationData: waitData
      }
    }
  },
  async created () {
    this.$bus.$emit('ready')
    // 三秒后跳转授信结果页面
    setTimeout(() => {
      if (this.status) {
        this.$router.replace(`/authentication/result?applyNo=${this.applyNo}`)
      } else {
        this.$router.replace(`/withdraw/result?loanApplyNo=${this.applyNo}`)
      }
    }, 3000)
  },
  methods: {
    navigateToHome () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.auditing-page {
  padding-top: 150px;
  padding-bottom: 50px;
  .auditing-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .auditing-lottie{
      width: 210px !important;
      height: 210px !important;
    }
    .auditing-title {
      font-size: 42px;
      color: #333;
      margin-top: 30px;
      line-height: 60px;
    }
    .auditing-info{
      font-size: 26px;
      color: #666666;
      line-height: 37px;
      margin-top: 15px;
    }
    .auditing-button{
      width: 320px;
      height: 80px;
      line-height: 76px;
      border: 2px solid #FF4633;
      text-align: center;
      font-size: 32px;
      color: #FF4633;
      border-radius: 40px;
      margin-top: 176px;
    }
  }
  .auditing-bottom{
    position: fixed;
    width: 670px;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    .bottom-img{
      width: 100%;
    }
  }
}
</style>